<script>
export default {
    name: 'GRNPrint',
     data () {
        return {
            grnDetails: {},
            grnLines: []
        };
    },

     
    mounted(){ 
    
        this.fetchGRNDetails().then(() => {
            this.fetchGRNLines().then(() => {
                window.print();
            //  window.onafterprint = function() { window.close() }; 
            });
            });
 
    }
,
computed:{
    grandTotal(){
let totals=0;
totals=this.grnLines.map(g=>g.grandTotal).reduce((sum,amt)=>sum+amt,0);
        return totals;
    }

},
    methods: {

        fetchGRNDetails () {
         return   this.$http.get(`SupplierGRN/GetSpecificGRN?GRNNO=${this.$router.currentRoute.params.GRNNO}`).then(response => {
                this.grnDetails = response.data[0];
              //  this.fetchGRNLines();
            });
        }, 

        fetchGRNLines () {
          return  this.$http.get(`SupplierGRN/PostedGRNDetails?GRNNO=${this.$router.currentRoute.params.GRNNO}&UserName=${this.grnDetails.userName}`)
                .then(response => {
                    this.grnLines = response.data;
                });
        }
        ,
        print(){
            window.print();
        },
         
    }
}
</script>

<template>
    <div class="w-full">
      
         <tail-address-header></tail-address-header>
         <div class="flex justify-center p-2">
            <h3 class="text-center font-bold text-blue-400 text-sm">GOODS RETURN NOTE</h3>
        </div>
          
        <div class="flex flex-row w-full p-1">
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Supplier: {{ grnDetails.supplier }}</h4>
            </div> <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Date: {{ grnDetails.txnDate | dateFormat }}</h4>
            </div>
            <div class="flex-1 px-1">
               <h4 class="font-bold text-sm">Grn No: {{ grnDetails.grnNo }}</h4> 
            </div>
         
        </div>
         <div class="w-full">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="text-sm">Item</th>
                        <th class="text-sm">LPO Qty</th>
                        <th class="text-sm">Qty</th>
                        <th class="text-sm">Price</th>
                        <th class="text-sm">GRNID</th>
                        <th class="text-sm">Grand Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(grnLine, index) in grnLines" :key="index">
                        <td class="text-xs">{{ grnLine.itemName }}</td>
                        <td class="text-xs">{{ grnLine.orderedQty }}</td>
                        <td class="text-xs">{{ grnLine.qty }}</td>
                        <td class="text-xs">{{ grnLine.unitPrice }}</td>
                        <td class="text-xs">{{ grnLine.grnid }}</td>
                        <td class="text-xs justify-end">{{ grnLine.grandTotal }}</td>
                    </tr>
                </tbody>
            </table>
        </div> 
        <div class="flex flex-wrap w-full my-2 p-1 border-2 bg-gray-200">
          
          <div class="flex-1 flex justify-end"><b>Grand Total: </b><span class="font-bold ml-1"> {{ grandTotal | numberFormat }}</span></div>
        </div>
         <!-- <div class="w-full my-2 p-1 border-2 bg-gray-200 text-right">
            
                       <button @click.prevent="print"
                    class="btn-sm btn-info text-sm rounded justify-end"><i class="fa fa-print"></i> Print</button>
         
        </div> -->
    </div>
</template>
